<div class="container-fluid">
    <div class="roles">
        <div class="select-role-header-logo">
            <img class="aajeevika-logo" src="https://cdn.lokos.in/aajeevika/assets/img/aajeevika-logo.svg" alt="">
        </div>
        <h1>AAJEEVIKA REGISTER</h1>
        <h1>आजीविका रजिस्टर</h1>
        <h1 class="select-role-heading">Select your Role</h1>
        <div class="select-roles">
            <button type="button" (click)="navigateToPashuSakhi()">Pashu Sakhi</button>
            <button type="button" (click)="navigateToPashuSakhi()">CLF Bookkeeper</button>
            <button type="button" (click)="navigateToPashuSakhi()">Krishi Sakhi</button>
        </div>
        <div class="select-role-footer-logo">
            <img class="aajeevika-logo" src="https://cdn.lokos.in/aajeevika/assets/img/aajeevika-logo.svg" alt="">
            <div class="vl"></div>
            <img class="digital-india-logo" src="https://cdn.lokos.in/aajeevika/assets/img/digitalIndiaLogo.svg" alt="">
        </div>
    </div>
</div>